<template>
  <OrderItemApplyAllPopover ref="applyPopover" headerTitle="Apply Customer Approval" :itemList="validItemList" @applySettings="applySettings">

    <div class="row">
      <div class="col-10 col-form-label">Customer Approval</div>
      <div class="col-2 pl-0"><FormCheckbox v-model="requiresCustomerApproval" /></div>
    </div>

    <div class="m-3" />

  </OrderItemApplyAllPopover>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import OrderItemApplyAllPopover from '@/modules/orders/components/orderItemApplyAllPopover.vue'

import { InventoryStockTypes } from '@/store/types'

export default {
  name: 'OrderItemApplyAllCustomerApprovalPopover',
  mixins: [form],
  components: {
    OrderItemApplyAllPopover
  },
  props: {
    itemList: Array
  },
  computed: {
  },
  data() {
    return {
      requiresCustomerApproval: false,
      validItemList: []
    }
  },
  methods: {
    displayFromElement(element) {
      this.requiresCustomerApproval = false

      this.validItemList = this.itemList
      .filter(item => item.stockId != null && item.parentOrderItemId == null)
      .map(item => {
        var name = `${item.stock.code} - ${item.stock.name}`
        let parentItem = this.itemList.find(parentItem => parentItem.id == item.parentOrderItemId)
        if(parentItem)
          name = `${parentItem.stock.code}<i class="fas fa-caret-right mx-2"></i>${name}`

        if(item.stockType == InventoryStockTypes.glass)
          name += ` - ${item.glassHeight}x${item.glassWidth}`

        return {
          id: item.id,
          name: name
        }
      })

      this.$refs.applyPopover.displayFromElement(element)
    },
    
    applySettings(itemList) {

      this.$emit('applyApproval', {
        requiresCustomerApproval: this.requiresCustomerApproval,
        itemList: itemList
      })
    }
    
  }
}
</script>